export default function TokenBlock() {
  return (
    <>
      <path
        d="M336.573 35H28.4274C23.728 35 19.9184 50.7823 19.9184 70.2509V173.749C16.4166 196.179 23.728 209 28.4274 209H336.573C341.272 209 348.583 194.958 345.082 173.749V70.2509C345.082 50.7823 341.272 35 336.573 35Z"
        fill="#17074B"
      />
      <path
        opacity="0.64"
        d="M346 42H20V97H346V42Z"
        fill="url(#paint0_radial_298_610)"
      />
      <path
        opacity="0.64"
        d="M344.922 206.73L20 209V153H346L344.922 206.73Z"
        fill="url(#paint1_radial_298_610)"
      />
      <path
        opacity="0.64"
        d="M346 97H20V153H346V97Z"
        fill="url(#paint2_radial_298_610)"
      />
      <g filter="url(#filter0_d_298_610)">
        <path
          d="M330.932 33H34.4318C31.6178 32.9985 28.8312 33.5515 26.231 34.6274C23.6309 35.7032 21.2682 37.2808 19.2779 39.27C17.2876 41.2593 15.7088 43.6211 14.6316 46.2207C13.5544 48.8203 13 51.6067 13 54.4206L13 190.955C13 202.798 22.0324 213.5 33.8641 213.5H330.364C342.196 213.5 352.341 202.798 352.341 190.966V54.4318C352.343 51.6188 351.79 48.833 350.715 46.2336C349.64 43.6342 348.063 41.2719 346.075 39.2818C344.087 37.2917 341.727 35.7126 339.128 34.6348C336.53 33.557 333.745 33.0015 330.932 33ZM217.936 41.2922L194.006 49.0001C186.974 51.2597 179.411 51.2597 172.379 49.0001L148.449 41.2922C148.338 41.2396 148.248 41.152 148.192 41.0428C148.136 40.9337 148.118 40.8093 148.14 40.6888C148.163 40.5683 148.224 40.4585 148.315 40.3764C148.406 40.2943 148.521 40.2445 148.643 40.2348H217.775C217.895 40.2494 218.007 40.3028 218.094 40.3868C218.181 40.4708 218.239 40.5809 218.258 40.7005C218.277 40.82 218.256 40.9425 218.199 41.0492C218.142 41.156 218.052 41.2413 217.942 41.2922H217.936ZM213.095 206.265H153.29C153.026 206.263 152.772 206.168 152.572 205.995C152.372 205.823 152.24 205.585 152.199 205.324C152.158 205.063 152.211 204.796 152.349 204.571C152.487 204.346 152.7 204.177 152.951 204.095L172.207 197.917C179.352 195.619 187.038 195.619 194.184 197.917L213.44 204.117C213.677 204.21 213.875 204.38 214.001 204.601C214.127 204.822 214.174 205.079 214.134 205.33C214.093 205.581 213.968 205.811 213.779 205.981C213.59 206.151 213.349 206.251 213.095 206.265ZM345.118 192.079C345.118 195.842 343.623 199.45 340.963 202.11C338.302 204.771 334.694 206.265 330.932 206.265H244.722C243.787 206.265 242.858 206.121 241.967 205.837L239.813 205.152L194.117 190.599C187.012 188.337 179.379 188.347 172.279 190.627L127.006 205.152L125.13 205.753C124.073 206.093 122.969 206.265 121.858 206.265H34.4206C30.6583 206.265 27.0501 204.771 24.3897 202.11C21.7294 199.45 20.2348 195.842 20.2348 192.079V53.8752C20.2312 52.0848 20.5807 50.3112 21.2635 48.6561C21.9464 47.001 22.949 45.4968 24.214 44.2297C25.479 42.9626 26.9815 41.9576 28.6355 41.2721C30.2895 40.5866 32.0625 40.2341 33.853 40.2348H117.74C120.898 40.2343 124.038 40.7262 127.045 41.6929L172.468 56.2683C179.458 58.5027 186.971 58.5027 193.961 56.2683L238.979 41.9322C242.557 40.8007 246.289 40.2282 250.042 40.2348H331.5C333.288 40.2341 335.059 40.5858 336.712 41.2699C338.364 41.9541 339.866 42.9571 341.131 44.2219C342.395 45.4866 343.398 46.9881 344.083 48.6407C344.767 50.2932 345.118 52.0644 345.118 53.853V192.079Z"
          fill="#21369C"
        />
      </g>
      <path
        d="M183.339 48.6783C185.183 48.6783 186.678 47.1833 186.678 45.3391C186.678 43.495 185.183 42 183.339 42C181.495 42 180 43.495 180 45.3391C180 47.1833 181.495 48.6783 183.339 48.6783Z"
        fill="#27357B"
      />
      <path
        d="M183.339 204.678C185.183 204.678 186.678 203.183 186.678 201.339C186.678 199.495 185.183 198 183.339 198C181.495 198 180 199.495 180 201.339C180 203.183 181.495 204.678 183.339 204.678Z"
        fill="#27357B"
      />
      <g filter="url(#filter1_f_298_610)">
        <ellipse
          cx="183"
          cy="111"
          rx="126"
          ry="54"
          fill="#0A002B"
          fillOpacity="0.3"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_298_610"
          x="5.70953"
          y="27.9356"
          width="353.922"
          height="195.081"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.2261" />
          <feGaussianBlur stdDeviation="3.64523" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_298_610"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_298_610"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_f_298_610"
          x="0.957996"
          y="0.957996"
          width="364.084"
          height="220.084"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="28.021"
            result="effect1_foregroundBlur_298_610"
          />
        </filter>
        <radialGradient
          id="paint0_radial_298_610"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(94.6242 62.6937) scale(88.8898 188.917)"
        >
          <stop stopColor="#190F63" stopOpacity="0.8" />
          <stop offset="1" stopColor="#17074B" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_298_610"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(183 181.325) scale(115.62 250.737)"
        >
          <stop stopColor="#190D5C" />
          <stop offset="0.95" stopColor="#17074C" />
          <stop offset="1" stopColor="#17074B" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_298_610"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(270.912 121.461) scale(127.877 276.718)"
        >
          <stop offset="0.08" stopColor="#170758" />
          <stop offset="0.43" stopColor="#170751" />
        </radialGradient>
      </defs>
    </>
  );
}
